var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-user" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("user")) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-xs" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("personal_data")))
          ])
        ]),
        _vm.register_fields.name
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-input", {
                  ref: "full_name",
                  attrs: {
                    "float-label":
                      _vm.$t("name_and_last_name") +
                      " " +
                      _vm.hasObrigatory("full_name"),
                    error: _vm.$v.full_name.$error,
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.full_name.$touch },
                  model: {
                    value: _vm.full_name,
                    callback: function($$v) {
                      _vm.full_name = $$v
                    },
                    expression: "full_name"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.nick_name
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-input", {
                  ref: "nick_name",
                  attrs: {
                    "float-label":
                      _vm.$t("nick_name") +
                      " " +
                      _vm.hasObrigatory("nick_name"),
                    disable: _vm.disableDataWebservice || _vm.managerUser,
                    error: _vm.$v.nick_name.$error
                  },
                  on: { input: _vm.$v.nick_name.$touch },
                  model: {
                    value: _vm.nick_name,
                    callback: function($$v) {
                      _vm.nick_name = $$v
                    },
                    expression: "nick_name"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.email_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.email_error || _vm.email_error_prefix,
                      "error-label": _vm.messageErrorEmail
                    }
                  },
                  [
                    _c("q-input", {
                      ref: "email",
                      attrs: {
                        type: "email",
                        "float-label":
                          _vm.$t("email") + " " + _vm.hasObrigatory("email"),
                        error: _vm.$v.email.$error,
                        disable: _vm.disableDataWebservice || _vm.managerUser
                      },
                      on: {
                        input: _vm.$v.email.$touch,
                        blur: function($event) {
                          return _vm.validateEmail()
                        }
                      },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.email_error && _vm.id_user
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    size: "small",
                    label: _vm.$t("edit_user_found"),
                    icon: "far fa-edit"
                  },
                  on: {
                    click: function($event) {
                      return _vm.openUser()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_store.use_document_mask && _vm.countries.length > 1
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-select", {
                  ref: "country_of_residence",
                  attrs: {
                    options: _vm.countries.map(function(e) {
                      return Object.assign({}, e, { label: _vm.$t(e.label) })
                    }),
                    "float-label": _vm.$t("country_of_residence"),
                    clearable: "",
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: {
                    clear: function($event) {
                      _vm.document = ""
                    }
                  },
                  model: {
                    value: _vm.user_country,
                    callback: function($$v) {
                      _vm.user_country = $$v
                    },
                    expression: "user_country"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.document && _vm.register_store.use_document_mask
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value:
                        "" +
                        _vm.$mask.document(
                          Object.assign({}, _vm.userCountryObjected, {
                            config: _vm.register_store.use_document_mask
                          })
                        ),
                      expression:
                        "\n\t\t\t\t\t`${$mask.document({\n\t\t\t\t\t\t...userCountryObjected,\n\t\t\t\t\t\tconfig: register_store.use_document_mask,\n\t\t\t\t\t})}`\n\t\t\t\t"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.document,
                      expression: "document"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.document },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.document = $event.target.value
                    }
                  }
                }),
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.document_error || _vm.document_invalid,
                      "error-label": _vm.$t(_vm.documentError)
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value:
                            "" +
                            _vm.$mask.document(
                              Object.assign({}, _vm.userCountryObjected, {
                                config: _vm.register_store.use_document_mask
                              })
                            ),
                          expression:
                            "\n\t\t\t\t\t\t`${$mask.document({\n\t\t\t\t\t\t\t...userCountryObjected,\n\t\t\t\t\t\t\tconfig: register_store.use_document_mask,\n\t\t\t\t\t\t})}`\n\t\t\t\t\t"
                        }
                      ],
                      ref: "document",
                      attrs: {
                        "float-label":
                          _vm.$t(_vm.documentIsCPF) +
                          " " +
                          _vm.hasObrigatory("document"),
                        error: _vm.$v.document.$error,
                        disable:
                          _vm.disableDataWebservice ||
                          _vm.managerUser ||
                          _vm.user_country == null
                      },
                      on: {
                        input: _vm.$v.document.$touch,
                        blur: function($event) {
                          return _vm.documentUnique()
                        },
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                        }
                      },
                      model: {
                        value: _vm.document,
                        callback: function($$v) {
                          _vm.document = $$v
                        },
                        expression: "document"
                      }
                    })
                  ],
                  1
                ),
                _vm.isChevrolet &&
                _vm.id_user_language_selected == 1 &&
                _vm.id_user_client_country_selected == 32
                  ? _c("small", { staticClass: "text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("document_exemple")))
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.document && !_vm.register_store.use_document_mask
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.document_error || _vm.document_invalid,
                      "error-label": _vm.$t(_vm.documentError)
                    }
                  },
                  [
                    _c("q-input", {
                      ref: "document",
                      attrs: {
                        "float-label":
                          _vm.$t(_vm.documentIsCPF) +
                          " " +
                          _vm.hasObrigatory("document"),
                        error: _vm.$v.document.$error,
                        disable: _vm.disableDataWebservice || _vm.managerUser
                      },
                      on: {
                        input: _vm.$v.document.$touch,
                        blur: function($event) {
                          return _vm.documentUnique()
                        },
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                        }
                      },
                      model: {
                        value: _vm.document,
                        callback: function($$v) {
                          _vm.document = $$v
                        },
                        expression: "document"
                      }
                    })
                  ],
                  1
                ),
                _vm.isChevrolet &&
                _vm.id_user_language_selected == 1 &&
                _vm.id_user_client_country_selected == 32
                  ? _c("small", { staticClass: "text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("document_exemple")))
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.register && !_vm.isChevrolet
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.register_error,
                      "error-label": _vm.register_error
                        ? _vm.$t("register_not_unique")
                        : ""
                    }
                  },
                  [
                    _c("q-input", {
                      ref: "register",
                      attrs: {
                        "float-label":
                          _vm.$t("register") +
                          " " +
                          _vm.hasObrigatory("register"),
                        error: _vm.$v.register.$error,
                        disable: _vm.disableDataWebservice || _vm.managerUser
                      },
                      on: {
                        input: _vm.$v.register.$touch,
                        blur: function($event) {
                          return _vm.registerUnique()
                        }
                      },
                      model: {
                        value: _vm.register,
                        callback: function($$v) {
                          _vm.register = $$v
                        },
                        expression: "register"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_error ? _c("div", { staticClass: "col-sm-6" }) : _vm._e(),
        (_vm.document_error || _vm.register_error) && _vm.id_user
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    size: "small",
                    label: _vm.$t("edit_user_found"),
                    icon: "far fa-edit"
                  },
                  on: {
                    click: function($event) {
                      return _vm.openUser()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.document_error ? _c("div", { staticClass: "col-sm-6" }) : _vm._e(),
        _vm.register_fields.register_2
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.register_2_error,
                      "error-label": _vm.register_2_error
                        ? _vm.$t("gmin_number_not_unique")
                        : ""
                    }
                  },
                  [
                    _c("q-input", {
                      ref: "register_2",
                      attrs: {
                        disable: "",
                        "float-label":
                          _vm.$t("gmin_number") +
                          " " +
                          _vm.hasObrigatory("gmin_number"),
                        error: _vm.$v.register_2.$error,
                        disable: _vm.disableDataWebservice || _vm.managerUser
                      },
                      on: {
                        input: _vm.$v.register_2.$touch,
                        blur: function($event) {
                          return _vm.register2Unique()
                        }
                      },
                      model: {
                        value: _vm.register_2,
                        callback: function($$v) {
                          _vm.register_2 = $$v
                        },
                        expression: "register_2"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.birthday
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-datetime", {
                  ref: "birthday",
                  attrs: {
                    type: "date",
                    "float-label":
                      _vm.$t("birthday") + " " + _vm.hasObrigatory("birthday"),
                    format: "DD/MM/YYYY",
                    error: _vm.$v.birthday.$error,
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.birthday.$touch },
                  model: {
                    value: _vm.birthday,
                    callback: function($$v) {
                      _vm.birthday = $$v
                    },
                    expression: "birthday"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.gender
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-select", {
                  ref: "gender",
                  attrs: {
                    options: _vm.getUserGenders,
                    "float-label":
                      _vm.$t("gender") + " " + _vm.hasObrigatory("gender"),
                    error: _vm.$v.gender.$error,
                    clearable: "",
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.gender.$touch },
                  model: {
                    value: _vm.gender,
                    callback: function($$v) {
                      _vm.gender = $$v
                    },
                    expression: "gender"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.number_of_children
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  ref: "number_of_children",
                  attrs: {
                    type: "number",
                    "float-label":
                      _vm.$t("number_of_children") +
                      " " +
                      _vm.hasObrigatory("number_of_children"),
                    error: _vm.$v.number_of_children.$error,
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.number_of_children.$touch },
                  model: {
                    value: _vm.number_of_children,
                    callback: function($$v) {
                      _vm.number_of_children = $$v
                    },
                    expression: "number_of_children"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.marital_status
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-select", {
                  ref: "marital_status",
                  attrs: {
                    options: _vm.marital_statuss,
                    error: _vm.$v.marital_status.$error,
                    "float-label":
                      _vm.$t("marital") +
                      " " +
                      _vm.hasObrigatory("marital_status"),
                    clearable: "",
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.marital_status.$touch },
                  model: {
                    value: _vm.marital_status,
                    callback: function($$v) {
                      _vm.marital_status = $$v
                    },
                    expression: "marital_status"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row gutter-xs" }, [
        _vm.register_fields.is_handicapped
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-select", {
                  ref: "is_handicapped",
                  attrs: {
                    options: [
                      { value: true, label: _vm.$t("yes") },
                      { value: false, label: _vm.$t("no") }
                    ],
                    "float-label":
                      _vm.$t("is_handicapped") +
                      " " +
                      _vm.hasObrigatory("is_handicapped"),
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  model: {
                    value: _vm.is_handicapped,
                    callback: function($$v) {
                      _vm.is_handicapped = $$v
                    },
                    expression: "is_handicapped"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.handicap_description
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  ref: "handicap_description",
                  attrs: {
                    "float-label":
                      _vm.$t("handicap_description") +
                      " " +
                      _vm.hasObrigatory("handicap_description"),
                    error: _vm.$v.handicap_description.$error,
                    disable:
                      _vm.disableDataWebservice ||
                      _vm.managerUser ||
                      !_vm.is_handicapped
                  },
                  on: { input: _vm.$v.handicap_description.$touch },
                  model: {
                    value: _vm.handicap_description,
                    callback: function($$v) {
                      _vm.handicap_description = $$v
                    },
                    expression: "handicap_description"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row gutter-xs" }, [
        _vm.showPhones
          ? _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
              _c("span", { staticClass: "q-headline text-weight-light" }, [
                _vm._v(_vm._s(_vm.$t("phone_number")))
              ])
            ])
          : _vm._e(),
        _vm.register_fields.mobile_phone_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  ref: "phone_mobile",
                  attrs: {
                    "float-label":
                      _vm.$t("mobile") +
                      " " +
                      _vm.hasObrigatory("phone_mobile"),
                    error: _vm.$v.phone_mobile.phone.$error,
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.phone_mobile.phone.$touch },
                  model: {
                    value: _vm.phone_mobile.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_mobile, "phone", $$v)
                    },
                    expression: "phone_mobile.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.whatsapp_phone_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  ref: "phone_whatsapp",
                  attrs: {
                    "float-label":
                      _vm.$t("whatsapp") +
                      " " +
                      _vm.hasObrigatory("whatsapp_phone"),
                    error: _vm.$v.phone_whatsapp.phone.$error,
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.phone_whatsapp.phone.$touch },
                  model: {
                    value: _vm.phone_whatsapp.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_whatsapp, "phone", $$v)
                    },
                    expression: "phone_whatsapp.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.commercial_phone_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  ref: "phone_commercial",
                  attrs: {
                    "float-label":
                      _vm.$t("commercial") +
                      " " +
                      _vm.hasObrigatory("commercial_phone"),
                    error: _vm.$v.phone_commercial.phone.$error,
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.phone_commercial.phone.$touch },
                  model: {
                    value: _vm.phone_commercial.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_commercial, "phone", $$v)
                    },
                    expression: "phone_commercial.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.residential_phone_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-input", {
                  ref: "phone_residential",
                  attrs: {
                    "float-label":
                      _vm.$t("residential") +
                      " " +
                      _vm.hasObrigatory("residential_phone"),
                    error: _vm.$v.phone_residential.phone.$error,
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.phone_residential.phone.$touch },
                  model: {
                    value: _vm.phone_residential.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_residential, "phone", $$v)
                    },
                    expression: "phone_residential.phone"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
              _c("span", { staticClass: "q-headline text-weight-light" }, [
                _vm._v(_vm._s(_vm.$t("address")))
              ])
            ])
          : _vm._e(),
        _vm.keyGooogleMaps && _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.show_maps_alert,
                      "error-label": _vm.$t(
                        "not_found_check_that_the_search_is_spelled_correctly_Try_adding_a_city_state_or_zip_code"
                      )
                    }
                  },
                  [
                    _c(
                      "q-input",
                      {
                        ref: "address",
                        attrs: {
                          "float-label":
                            _vm.$t("address") +
                            " " +
                            _vm.hasObrigatory("address"),
                          autocomplete: "new-password",
                          error: _vm.$v.address.$error,
                          placeholder: _vm.$t(
                            "search_by_name_and_street_number"
                          )
                        },
                        on: { input: _vm.$v.address.$touch },
                        model: {
                          value: _vm.address,
                          callback: function($$v) {
                            _vm.address = $$v
                          },
                          expression: "address"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: { "min-characters": 3, separator: "" },
                          on: {
                            search: _vm.getAddressGoogleMaps,
                            selected: _vm.selectedAddressGoogleMaps
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : !_vm.keyGooogleMaps && _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-input",
                  {
                    attrs: {
                      "float-label":
                        _vm.$t("address") + " " + _vm.hasObrigatory("address"),
                      autocomplete: "new-password",
                      error: _vm.$v.address.$error,
                      disable: _vm.disableDataWebservice || _vm.managerUser
                    },
                    on: { input: _vm.$v.address.$touch },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  },
                  [
                    _c("q-autocomplete", {
                      attrs: { "min-characters": 3, separator: "" },
                      on: {
                        search: _vm.getAddress,
                        selected: _vm.selectedAddress
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  ref: "number",
                  attrs: {
                    "float-label": _vm.$t("number"),
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  model: {
                    value: _vm.number,
                    callback: function($$v) {
                      _vm.number = $$v
                    },
                    expression: "number"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("complement"),
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  model: {
                    value: _vm.complement,
                    callback: function($$v) {
                      _vm.complement = $$v
                    },
                    expression: "complement"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("neighborhood"),
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  model: {
                    value: _vm.neighborhood,
                    callback: function($$v) {
                      _vm.neighborhood = $$v
                    },
                    expression: "neighborhood"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("postal_code"),
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  model: {
                    value: _vm.postal_code,
                    callback: function($$v) {
                      _vm.postal_code = $$v
                    },
                    expression: "postal_code"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  ref: "city",
                  attrs: {
                    "float-label":
                      _vm.$t("city") + " " + _vm.hasObrigatory("city"),
                    error: _vm.$v.city.$error,
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.city.$touch },
                  model: {
                    value: _vm.city,
                    callback: function($$v) {
                      _vm.city = $$v
                    },
                    expression: "city"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.address_fields
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  ref: "state",
                  attrs: {
                    "float-label":
                      _vm.$t("state") + " " + _vm.hasObrigatory("state"),
                    error: _vm.$v.state.$error,
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.state.$touch },
                  model: {
                    value: _vm.state,
                    callback: function($$v) {
                      _vm.state = $$v
                    },
                    expression: "state"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
          _vm.register_fields.regional ||
          _vm.register_fields.company ||
          _vm.register_fields.store ||
          _vm.register_fields.managers ||
          _vm.register_fields.admission_date
            ? _c("span", { staticClass: "q-headline text-weight-light" }, [
                _vm._v(_vm._s(_vm.$t("organization_data")))
              ])
            : _vm._e()
        ]),
        _vm.register_fields.regional
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  ref: "branch_regionals",
                  attrs: {
                    multiple: "",
                    chips: "",
                    options: _vm.branch_regional,
                    error: _vm.$v.branch_regionals.$error,
                    "float-label":
                      _vm.$t("regionals") +
                      " (" +
                      _vm.branch_regionals.length +
                      ") " +
                      _vm.hasObrigatory("branch_regionals"),
                    disable:
                      _vm.disableDataWebservice ||
                      _vm.managerUser ||
                      _vm.hasCreateStore
                  },
                  on: { input: _vm.$v.branch_regionals.$touch },
                  model: {
                    value: _vm.branch_regionals,
                    callback: function($$v) {
                      _vm.branch_regionals = $$v
                    },
                    expression: "branch_regionals"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.company
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-chips-input",
                  {
                    ref: "companies_label",
                    attrs: {
                      "add-icon": "   ",
                      "float-label":
                        _vm.$t("companies_or_chains") +
                        " (" +
                        _vm.companies_label.length +
                        ") " +
                        _vm.hasObrigatory("companies_label"),
                      error: _vm.$v.companies_label.$error,
                      disable:
                        _vm.disableDataWebservice ||
                        _vm.managerUser ||
                        _vm.hasCreateStore
                    },
                    on: {
                      input: _vm.verifyLabelCompany,
                      remove: _vm.removeHeadquarter
                    },
                    model: {
                      value: _vm.companies_label,
                      callback: function($$v) {
                        _vm.companies_label = $$v
                      },
                      expression: "companies_label"
                    }
                  },
                  [
                    _c("q-autocomplete", {
                      attrs: { "min-characters": 1, "max-results": 100 },
                      on: {
                        search: _vm.fetchHeadquarters,
                        selected: _vm.selectHeadquarter
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.store
          ? _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
              _c("div", { staticClass: "row gutter-sm" }, [
                _vm.register_store.store_as_list
                  ? _c(
                      "div",
                      {
                        class:
                          _vm.inactive_company_branches_label.length > 0
                            ? "col-xs-12 col-lg-6"
                            : "col-xs-12"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "full-width" },
                          [
                            _c("q-select", {
                              ref: "company_branches",
                              staticClass: "full-width",
                              attrs: {
                                multiple: "",
                                filter: "",
                                "autofocus-filter": "",
                                chips: "",
                                options: _vm.list_branches,
                                "float-label":
                                  _vm.$t("stores_or_branches") +
                                  " (" +
                                  _vm.company_branches.length +
                                  ") " +
                                  _vm.hasObrigatory("company_branches"),
                                error: _vm.$v.company_branches.$error,
                                disable:
                                  _vm.disableDataWebservice ||
                                  _vm.managerUser ||
                                  _vm.hasCreateStore
                              },
                              on: { input: _vm.$v.company_branches.$touch },
                              model: {
                                value: _vm.company_branches,
                                callback: function($$v) {
                                  _vm.company_branches = $$v
                                },
                                expression: "company_branches"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                !_vm.register_store.store_as_list
                  ? _c(
                      "div",
                      {
                        class:
                          _vm.inactive_company_branches_label.length > 0
                            ? "col-xs-12 col-lg-6"
                            : "col-xs-12"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "full-width" },
                          [
                            _c(
                              "q-chips-input",
                              {
                                ref: "company_branches_label",
                                staticClass: "full-width",
                                attrs: {
                                  "add-icon": "   ",
                                  "float-label":
                                    _vm.$t("stores_or_branches") +
                                    " (" +
                                    _vm.company_branches_label.length +
                                    ") " +
                                    _vm.hasObrigatory("company_branches_label"),
                                  error: _vm.$v.company_branches_label.$error,
                                  disable:
                                    _vm.disableDataWebservice || _vm.managerUser
                                },
                                on: {
                                  remove: _vm.removeBranch,
                                  input: _vm.verifyLabelBranch
                                },
                                model: {
                                  value: _vm.company_branches_label,
                                  callback: function($$v) {
                                    _vm.company_branches_label = $$v
                                  },
                                  expression: "company_branches_label"
                                }
                              },
                              [
                                _c("q-autocomplete", {
                                  attrs: {
                                    "min-characters": 3,
                                    "max-results": 100
                                  },
                                  on: {
                                    search: _vm.fetchBranches,
                                    selected: _vm.selectBranch
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.inactive_company_branches_label.length > 0
                  ? _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                      _c(
                        "div",
                        { staticClass: "full-width" },
                        [
                          _c("q-chips-input", {
                            ref: "inactive_company_branches_label",
                            staticClass: "full-width",
                            attrs: {
                              "add-icon": "   ",
                              maxlength: "0",
                              "float-label":
                                _vm.$t("inactive_stores_or_branches") +
                                " (" +
                                _vm.inactive_company_branches_label.length +
                                ")",
                              disable:
                                _vm.disableDataWebservice || _vm.managerUser
                            },
                            on: {
                              input: _vm.syncInactiveCompanyBranchesLabel,
                              remove: _vm.removeInactiveCompanyBranch
                            },
                            model: {
                              value: _vm.inactive_company_branches_label,
                              callback: function($$v) {
                                _vm.inactive_company_branches_label = $$v
                              },
                              expression: "inactive_company_branches_label"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm.register_fields.store && _vm.isChevrolet
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  attrs: {
                    filter: "",
                    "autofocus-filter": "",
                    options: _vm.getMainCompanyBranches,
                    "float-label": "" + _vm.$t("main_company_branch"),
                    error: _vm.$v.main_company_branch.$error,
                    disable:
                      _vm.disableDataWebservice ||
                      _vm.managerUser ||
                      _vm.hasCreateStore
                  },
                  on: { input: _vm.$v.main_company_branch.$touch },
                  model: {
                    value: _vm.main_company_branch,
                    callback: function($$v) {
                      _vm.main_company_branch = $$v
                    },
                    expression: "main_company_branch"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.managerCompanyBranchesGeneral.length > 0 && _vm.isVivara
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-field", { attrs: { label: _vm.$t("managers_general") } }),
                _vm._l(_vm.managerCompanyBranchesGeneral, function(
                  item,
                  index
                ) {
                  return _c(
                    "q-chip",
                    { key: index, attrs: { color: "primary" } },
                    [_vm._v(_vm._s(item))]
                  )
                })
              ],
              2
            )
          : _vm._e(),
        _vm.managerCompanyBranchesRegional.length > 0 && _vm.isVivara
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-field", {
                  attrs: { label: _vm.$t("managers_regional") }
                }),
                _vm._l(_vm.managerCompanyBranchesRegional, function(
                  item,
                  index
                ) {
                  return _c(
                    "q-chip",
                    { key: index, attrs: { color: "primary" } },
                    [_vm._v(_vm._s(item))]
                  )
                })
              ],
              2
            )
          : _vm._e(),
        _vm.managerCompanyBranches.length > 0
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-field", { attrs: { label: _vm.$t("store_manager") } }),
                _vm._l(_vm.managerCompanyBranches, function(item, index) {
                  return _c(
                    "q-chip",
                    { key: index, attrs: { color: "primary" } },
                    [_vm._v(_vm._s(item))]
                  )
                })
              ],
              2
            )
          : _vm._e(),
        _vm.hasCreateStore
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-input", {
                  ref: "company_branch_name",
                  attrs: {
                    "float-label":
                      _vm.$t("others") +
                      " " +
                      _vm.hasObrigatory("company_branch_name"),
                    disable: _vm.disableDataWebservice || _vm.managerUser,
                    error: _vm.$v.company_branch_name.$error
                  },
                  on: { input: _vm.$v.company_branch_name.$touch },
                  model: {
                    value: _vm.company_branch_name,
                    callback: function($$v) {
                      _vm.company_branch_name = $$v
                    },
                    expression: "company_branch_name"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.isChevrolet
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.register_error,
                      "error-label": _vm.register_error
                        ? _vm.$t("register_not_unique")
                        : ""
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: {
                        disable: "",
                        "float-label":
                          _vm.$t("register") +
                          " " +
                          _vm.hasObrigatory("register"),
                        error: _vm.$v.register.$error
                      },
                      on: {
                        input: _vm.$v.register.$touch,
                        blur: function($event) {
                          return _vm.registerUnique()
                        }
                      },
                      model: {
                        value: _vm.register,
                        callback: function($$v) {
                          _vm.register = $$v
                        },
                        expression: "register"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.managers
          ? _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "q-chips-input",
                  {
                    ref: "managers",
                    attrs: {
                      "add-icon": "   ",
                      "float-label":
                        _vm.$t("managers") +
                        " " +
                        _vm.hasObrigatory("managers"),
                      error: _vm.$v.managers.$error,
                      disable: _vm.disableDataWebservice || _vm.managerUser
                    },
                    on: {
                      input: _vm.$v.managers.$touch,
                      remove: _vm.removeManager
                    },
                    model: {
                      value: _vm.managers,
                      callback: function($$v) {
                        _vm.managers = $$v
                      },
                      expression: "managers"
                    }
                  },
                  [
                    _c("q-autocomplete", {
                      attrs: {
                        "min-characters": 3,
                        "value-field": function(v) {
                          return v.full_name + " - " + v.email
                        }
                      },
                      on: {
                        search: _vm.searchManager,
                        selected: _vm.selectManager
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.user_type &&
        _vm.id_user_client_country_selected == 32 &&
        _vm.id_user_client_selected == 1
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  attrs: {
                    filter: "",
                    "autofocus-filter": "",
                    disable: _vm.disableUserType,
                    options: _vm.getTrainingLocationOptions,
                    "float-label": _vm.$t("training_location") + "*"
                  },
                  model: {
                    value: _vm.user_type,
                    callback: function($$v) {
                      _vm.user_type = $$v
                    },
                    expression: "user_type"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.register_fields.admission_date
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-datetime", {
                  ref: "date_hiring",
                  attrs: {
                    type: "date",
                    error: _vm.$v.date_hiring.$error,
                    "float-label":
                      _vm.$t("admission_date") +
                      " " +
                      _vm.hasObrigatory("date_hiring"),
                    format: "DD/MM/YYYY",
                    disable: _vm.disableDataWebservice || _vm.managerUser
                  },
                  on: { input: _vm.$v.date_hiring.$touch },
                  model: {
                    value: _vm.date_hiring,
                    callback: function($$v) {
                      _vm.date_hiring = $$v
                    },
                    expression: "date_hiring"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "col-xs-12 col-sm-12 q-mt-lg",
            attrs: { id: "permissions" }
          },
          [
            _c("span", { staticClass: "q-headline text-weight-light" }, [
              _vm._v(_vm._s(_vm.$t("permissions")))
            ])
          ]
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 q-mt-md",
          attrs: { color: "secondary" },
          on: {
            select: function($event) {
              return _vm.changeTab()
            }
          },
          model: {
            value: _vm.selected_tab,
            callback: function($$v) {
              _vm.selected_tab = $$v
            },
            expression: "selected_tab"
          }
        },
        [
          _vm._l(_vm.user_clients, function(user_client, index) {
            return _vm.getClientName(user_client.client)
              ? _c("q-tab", {
                  key: "t" + index,
                  attrs: {
                    slot: "title",
                    name: "c" + user_client.client,
                    label: _vm.getClientName(user_client.client),
                    color: user_client.has_error ? "negative" : ""
                  },
                  slot: "title"
                })
              : _vm._e()
          }),
          _vm.user_clients_store && _vm.user_clients_store.length > 1
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  disable: _vm.managerUser,
                  name: "new",
                  icon: "fas fa-plus"
                },
                on: {
                  click: function($event) {
                    return _vm.addNewClient()
                  }
                },
                slot: "title"
              })
            : _vm._e(),
          _vm._l(_vm.user_clients, function(user_client, index) {
            return _c(
              "q-tab-pane",
              { key: "p" + index, attrs: { name: "c" + user_client.client } },
              [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("q-select", {
                        ref: "profile",
                        refInFor: true,
                        attrs: {
                          filter: "",
                          "autofocus-filter": "",
                          disable: _vm.managerUser,
                          options: _vm.getProfileOptions(user_client),
                          "float-label": _vm.$t("profile") + "*",
                          error: user_client.error_profile
                        },
                        on: {
                          input: function($event) {
                            return _vm.checkError(user_client)
                          }
                        },
                        model: {
                          value: user_client.profile,
                          callback: function($$v) {
                            _vm.$set(user_client, "profile", $$v)
                          },
                          expression: "user_client.profile"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.register_fields.user_type &&
                  _vm.id_user_client_country_selected == 32 &&
                  _vm.id_user_client_selected != 1
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-select", {
                            attrs: {
                              filter: "",
                              "autofocus-filter": "",
                              disable: _vm.managerUser,
                              options: _vm.getUserTypeOptions,
                              "float-label": _vm.$t("user_type") + "*"
                            },
                            model: {
                              value: _vm.user_type,
                              callback: function($$v) {
                                _vm.user_type = $$v
                              },
                              expression: "user_type"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showIncludeUserInGroup
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-select", {
                            ref: "user_groups",
                            refInFor: true,
                            attrs: {
                              filter: "",
                              "autofocus-filter": "",
                              disable: _vm.managerUser,
                              multiple: "",
                              options: user_client.client_user_groups
                                ? user_client.client_user_groups
                                : [],
                              "float-label":
                                _vm.$t("include_user_in_groups") + "*"
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkError(user_client)
                              }
                            },
                            model: {
                              value: user_client.user_groups,
                              callback: function($$v) {
                                _vm.$set(user_client, "user_groups", $$v)
                              },
                              expression: "user_client.user_groups"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                    _c("span", { staticClass: "q-caption text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("countries")) + " *")
                    ]),
                    _c(
                      "div",
                      { staticClass: "row gutter-sm" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-12" },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                disable: _vm.managerUser,
                                val: true,
                                label: _vm.$t("all")
                              },
                              on: {
                                input: function($event) {
                                  return _vm.checkAllCountries(user_client)
                                }
                              },
                              model: {
                                value: _vm.all_countries,
                                callback: function($$v) {
                                  _vm.all_countries = $$v
                                },
                                expression: "all_countries"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(_vm.getCountries(user_client.client), function(
                          item,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "col-xs-12 col-sm-4",
                              class: _vm.getErrorClass(
                                user_client.error_countries
                              )
                            },
                            [
                              _c("q-checkbox", {
                                ref: "user_client.countries",
                                refInFor: true,
                                attrs: {
                                  disable: _vm.managerUser,
                                  "keep-color": "",
                                  val: item.id,
                                  label: item.name,
                                  color: _vm.getErrorColor(
                                    user_client.error_countries
                                  )
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.checkError(user_client)
                                  }
                                },
                                model: {
                                  value: user_client.countries,
                                  callback: function($$v) {
                                    _vm.$set(user_client, "countries", $$v)
                                  },
                                  expression: "user_client.countries"
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-md" }, [
                    _c("span", { staticClass: "q-caption text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("areas")) + " *")
                    ]),
                    _c(
                      "div",
                      { staticClass: "row gutter-sm" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-12" },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                disable:
                                  _vm.managerUser || !user_client.profile,
                                val: true,
                                label: _vm.$t("all_f")
                              },
                              on: {
                                input: function($event) {
                                  return _vm.checkAllAreas(user_client)
                                }
                              },
                              model: {
                                value: _vm.all_areas,
                                callback: function($$v) {
                                  _vm.all_areas = $$v
                                },
                                expression: "all_areas"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(_vm.getAreas(user_client.client), function(
                          item,
                          index
                        ) {
                          return !_vm.register_store.store_as_list
                            ? _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "col-xs-12 col-sm-4",
                                  class: _vm.getErrorClass(
                                    user_client.error_area
                                  )
                                },
                                [
                                  _c("q-checkbox", {
                                    attrs: {
                                      disable: _vm.managerUser,
                                      "keep-color": "",
                                      val: item.value,
                                      label: item.label
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.checkError(user_client)
                                      }
                                    },
                                    model: {
                                      value: user_client.areas,
                                      callback: function($$v) {
                                        _vm.$set(user_client, "areas", $$v)
                                      },
                                      expression: "user_client.areas"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        _vm.register_store.store_as_list
                          ? _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12" },
                              [
                                _c("select-multiple", {
                                  attrs: {
                                    label: "areas",
                                    filters: user_client.areas,
                                    options: _vm.getAreas(user_client.client)
                                  },
                                  on: {
                                    on_value: function($event) {
                                      user_client.areas = $event
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showMainAreas
                          ? _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("q-select", {
                                  ref: "user_client.main_areas",
                                  refInFor: true,
                                  attrs: {
                                    "autofocus-filter": "",
                                    filter: "",
                                    options: _vm.getMainAreas(user_client),
                                    "float-label": _vm.$t("main_area") + "*",
                                    error: user_client.error_main_areas,
                                    disable: _vm.managerUser
                                  },
                                  model: {
                                    value: user_client.main_areas,
                                    callback: function($$v) {
                                      _vm.$set(user_client, "main_areas", $$v)
                                    },
                                    expression: "user_client.main_areas"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ]),
                  _vm.hasControlPanelAccess(user_client)
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12 q-mt-md" },
                        [
                          _c("span", { staticClass: "q-caption text-faded" }, [
                            _vm._v(_vm._s(_vm.$t("access")))
                          ]),
                          _c("div", { staticClass: "row gutter-sm q-mb-md" }, [
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12" },
                              [
                                _c("q-checkbox", {
                                  attrs: {
                                    disable: _vm.managerUser,
                                    val: true,
                                    label: _vm.$t("all")
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.checkAllModules(user_client)
                                    }
                                  },
                                  model: {
                                    value: _vm.all_modules,
                                    callback: function($$v) {
                                      _vm.all_modules = $$v
                                    },
                                    expression: "all_modules"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm.controlPannel(user_client.client).length > 0
                            ? _c(
                                "span",
                                { staticClass: "q-caption text-faded" },
                                [_vm._v(_vm._s(_vm.$t("control_pannel")))]
                              )
                            : _vm._e(),
                          _vm.controlPannel(user_client.client).length > 0
                            ? _c(
                                "div",
                                { staticClass: "row gutter-sm q-mb-md" },
                                _vm._l(
                                  _vm.controlPannel(user_client.client),
                                  function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "col-xs-12 col-sm-4"
                                      },
                                      [
                                        _c("q-checkbox", {
                                          attrs: {
                                            disable: _vm.managerUser,
                                            "keep-color": "",
                                            val: item.id,
                                            label: _vm.$t(item.slug)
                                          },
                                          model: {
                                            value: user_client.module_items,
                                            callback: function($$v) {
                                              _vm.$set(
                                                user_client,
                                                "module_items",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "user_client.module_items"
                                          }
                                        }),
                                        _c("q-tooltip", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(item.slug + "_tooltip")
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm.trainingManager(user_client.client).length > 0
                            ? _c(
                                "span",
                                { staticClass: "q-caption text-faded" },
                                [_vm._v(_vm._s(_vm.$t("presential")))]
                              )
                            : _vm._e(),
                          _vm.trainingManager(user_client.client).length > 0
                            ? _c(
                                "div",
                                { staticClass: "row gutter-sm q-mb-md" },
                                _vm._l(
                                  _vm.trainingManager(user_client.client),
                                  function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "col-xs-12 col-sm-4"
                                      },
                                      [
                                        _c("q-checkbox", {
                                          attrs: {
                                            disable: _vm.managerUser,
                                            "keep-color": "",
                                            val: item.id,
                                            label: _vm.$t(item.slug)
                                          },
                                          model: {
                                            value: user_client.module_items,
                                            callback: function($$v) {
                                              _vm.$set(
                                                user_client,
                                                "module_items",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "user_client.module_items"
                                          }
                                        }),
                                        _c("q-tooltip", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(item.slug + "_tooltip")
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm.rewards(user_client.client).length > 0
                            ? _c(
                                "span",
                                { staticClass: "q-caption text-faded" },
                                [_vm._v(_vm._s(_vm.$t("rewards")))]
                              )
                            : _vm._e(),
                          _vm.rewards(user_client.client).length > 0
                            ? _c(
                                "div",
                                { staticClass: "row gutter-sm q-mb-md" },
                                _vm._l(
                                  _vm.rewards(user_client.client),
                                  function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "col-xs-12 col-sm-4"
                                      },
                                      [
                                        _c("q-checkbox", {
                                          attrs: {
                                            disable: _vm.managerUser,
                                            "keep-color": "",
                                            val: item.id,
                                            label: _vm.$t(item.slug)
                                          },
                                          model: {
                                            value: user_client.module_items,
                                            callback: function($$v) {
                                              _vm.$set(
                                                user_client,
                                                "module_items",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "user_client.module_items"
                                          }
                                        }),
                                        _c("q-tooltip", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(item.slug + "_tooltip")
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
                    _c("div", { staticClass: "row reverse" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-3" },
                        [
                          _c("q-btn", {
                            staticClass: "fit",
                            attrs: {
                              disable: _vm.managerUser,
                              color: "negative",
                              icon: "fas fa-trash",
                              label: _vm.$t("remove_permission")
                            },
                            on: {
                              click: function($event) {
                                return _vm.confirmRemoveClient(
                                  user_client,
                                  index
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]
            )
          }),
          _c("q-tab-pane", { staticClass: "q-py-xl", attrs: { name: "new" } })
        ],
        2
      ),
      this.id != 0
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 q-mt-md" },
            [
              _c("q-input", {
                attrs: {
                  disable: true,
                  "float-label": _vm.$t("accept_terms_date")
                },
                model: {
                  value: _vm.accept_terms_date,
                  callback: function($$v) {
                    _vm.accept_terms_date = $$v
                  },
                  expression: "accept_terms_date"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "row gutter-xs q-mt-md" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("status")))
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.optionsStatus,
                "float-label": _vm.$t("status"),
                disable: _vm.disableDataWebservice,
                readonly: _vm.disableDataWebservice
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_users" })
                }
              }
            })
          ],
          1
        ),
        _vm.register_fields.default_password != "" &&
        _vm.id != 0 &&
        this.checkGeneratedEmail
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "warning",
                    icon: "fas fa-key",
                    label: _vm.$t("reset_user_password")
                  },
                  on: {
                    click: function($event) {
                      return _vm.resetUserPassword()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                disable: _vm.managerUser,
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _vm.showAnonymizeUserData && _vm.status === 13
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "warning",
                    label: _vm.$t("user_data_exclusion"),
                    icon: "fas fa-exclamation-circle"
                  },
                  on: {
                    click: function($event) {
                      _vm.show_anonymize_dialog = true
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.is_superuser || _vm.user_login_as_user
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label: _vm.$t("login_as_user"),
                    icon: "far fa-eye"
                  },
                  on: {
                    click: function($event) {
                      return _vm.loginAsUser()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.removeClient()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.show_confirmation_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeClient()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_confirmation_remove,
            callback: function($$v) {
              _vm.show_confirmation_remove = $$v
            },
            expression: "show_confirmation_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_permission")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t("do_you_really_want_to_remove_the_access_for_the_client")
              ) + "\n\t\t\t"
            ),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.getClientName(_vm.confirm_remove_client.client))
              )
            ]),
            _vm._v("? " + _vm._s(_vm.$t("all_permissions_will_be_lost")) + "!")
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { "no-backdrop-dismiss": "", "no-esc-dismiss": "" },
          on: {
            ok: function($event) {
              return _vm.addClient()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        return _vm.cancelAddClient()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("add") },
                    on: {
                      click: function($event) {
                        return _vm.addClient()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_add_client,
            callback: function($$v) {
              _vm.show_add_client = $$v
            },
            expression: "show_add_client"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("add_client")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-select", {
                attrs: { options: _vm.clientList },
                model: {
                  value: _vm.new_client,
                  callback: function($$v) {
                    _vm.new_client = $$v
                  },
                  expression: "new_client"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { "no-backdrop-dismiss": "", "no-esc-dismiss": "" },
          on: {
            ok: function($event) {
              return _vm.requestAnonymizeUserData(false)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "align-items": "flex-end"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            display: "flex",
                            "justify-content": "flex-end"
                          }
                        },
                        [
                          _c("q-btn", {
                            attrs: {
                              color: "tertiary",
                              label: _vm.$t("cancel")
                            },
                            on: {
                              click: function($event) {
                                return _vm.$router.push({ name: "admin_users" })
                              }
                            }
                          }),
                          _c("q-btn", {
                            attrs: {
                              color: "warning",
                              label: _vm.$t("reject"),
                              disabled: !_vm.is_admin && !_vm.is_superuser
                            },
                            on: {
                              click: function($event) {
                                return _vm.requestAnonymizeUserData(false)
                              }
                            }
                          }),
                          _c("q-btn", {
                            attrs: {
                              color: "negative",
                              label: _vm.$t("confirm"),
                              disabled: !_vm.is_admin && !_vm.is_superuser
                            },
                            on: {
                              click: function($event) {
                                return _vm.requestAnonymizeUserData(true)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.is_admin && !_vm.is_superuser
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-top": "8px",
                                "align-self": "flex-end",
                                color: "red",
                                "font-size": "12px"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t("anonymize_permission_text_info")
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_anonymize_dialog,
            callback: function($$v) {
              _vm.show_anonymize_dialog = $$v
            },
            expression: "show_anonymize_dialog"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("delete_user_data_confirmation")))
          ]),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("delete_user_data_warning_message")))
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("delete_user_data_mistake_message")))
            ]),
            _c("p", [_vm._v(_vm._s(_vm.$t("delete_user_data_danger_message")))])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }